import _ from "lodash";
import i18n from "i18next";

export const required = value => (!value ? i18n.t("formErrors.required") : undefined);

export const searchMinLength = value => (_.size(value) < 3 ? i18n.t("formErrors.minLength", { count: 3 }) : undefined);



// WEBPACK FOOTER //
// ./src/helpers/FormField/formFieldHelpers.js